{
  "name": "ui-angeion",
  "version": "4.0.28",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "prebuild:dev": "npm --no-git-tag-version version patch",
    "prebuild:sandbox": "npm --no-git-tag-version version patch",
    "prebuild:staging": "npm --no-git-tag-version version patch",
    "build:dev": "ng build --configuration development",
    "build:sandbox": "ng build --configuration sandbox",
    "build:staging": "ng build --configuration staging",
    "build:production": "ng build --configuration production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^17.0.0",
    "@angular/common": "^17.0.0",
    "@angular/compiler": "^17.0.0",
    "@angular/core": "^17.0.0",
    "@angular/forms": "^17.0.0",
    "@angular/platform-browser": "^17.0.0",
    "@angular/platform-browser-dynamic": "^17.0.0",
    "@angular/router": "^17.0.0",
    "@formio/angular": "^6.0.0-rc.8",
    "@formio/js": "^5.0.0-rc.37",
    "rxjs": "~7.8.0",
    "tesseract.js": "^5.0.4",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.2"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^17.0.6",
    "@angular/cli": "^17.0.6",
    "@angular/compiler-cli": "^17.0.0",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^20.10.8",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.2.2"
  }
}
